import api from './authService'

export interface PricingRequestData {
    firstName: string
    lastName: string
    email: string
    contactNumber: string
    description: string
}

export const pricingService = {
    async submitCustomPricing(data: PricingRequestData) {
        const response = await api.post('/custom-pricing', data)
        return response.data
    }
}
